import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createHead } from '@vueuse/head';
import 'vue-fast-marquee/style.css';
import Marquee from 'vue-fast-marquee';

import './assets/tailwind.css'


import "element-plus/dist/index.css";

import PaginaInicio from './pages/PaginaInicio.vue'
import QuienSoy from './pages/QuienSoy.vue'
import ServicesPage from './pages/ServicesPage.vue'
import ContactoPage from './pages/ContactoPage.vue'
import GaleriaPage from './pages/GaleriaPage.vue'
//import CheckoutPage from './pages/CheckoutPage.vue'
//import PaymentSuccessPage from './pages/PaymentSuccessPage.vue'
//import PaymentFailedPage from './pages/PaymentFailedPage.vue'


const routes = [
    { path: '/', name: 'PaginaInicio', component: PaginaInicio},
    { path: '/about', name: 'QuienSoy', component: QuienSoy},
    { path: '/services', name: 'ServicesPage', component: ServicesPage},
    { path: '/contact', name: 'ContactoPage', component: ContactoPage},
    { path: '/galeria', name: 'GaleriaPage', component: GaleriaPage},
    //{ path: '/checkout', name: 'CheckoutPage', component: CheckoutPage},
    //{ path: '/payment-success', name: 'PaymentSuccessPage', component: PaymentSuccessPage},
    //{ path: '/payment-failed', name: 'PaymentFailedPage', component: PaymentFailedPage},

    { path: '/:catchAll(.*)', redirect: '/' },
  ]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition; // Restaura posición al regresar
      } else {
        return { top: 0 }; // Desplaza la vista hacia arriba
      }
    },
  })
  
  




const app = createApp(App)
  // Usar router y montar la aplicación
const head = createHead();
app.use(head)
app.use(router);
app.use(Marquee);
app.mount('#app')